
export default {
    props: {
        steps: { type: Array, required: true },
        current: { type: Number, required: true },
    },
    watch: {
        // keep the active pill visible when the stepper overflows (DEMO L1599-1603)
        current: {
            immediate: true,
            handler () {
                this.$nextTick(() => {
                    const act = this.$el?.querySelector?.('.ck-stp.active')
                    if (act && this.$el.scrollTo) {
                        this.$el.scrollTo({ left: Math.max(0, act.offsetLeft - (this.$el.clientWidth - act.offsetWidth) / 2), behavior: 'smooth' })
                    }
                })
            },
        },
    },
    methods: {
        isClickable (i) {
            return i < this.current && this.current < this.steps.length - 1
        },
    },
}
